import React from 'react';

const ViewApprovedSheets = () => {
    return (
        <div className="view-approved-sheets-container">
            <div className="content-section">
                {/* Header Section */}
                <h3 style={{ fontSize: "20px", fontWeight: "300", color: "#000000", marginTop: "20px", marginBottom: "10px" }}>
                    Can I access my approved timesheets?
                </h3>

                {/* Description about approved timesheets */}
                <p className="description">
                    This section displays all the timesheets that have been approved by the approval manager and the super admin. 
                    Only the records that have passed through the entire approval process are visible here for tracking and review.
                </p>

                {/* Note Section */}
                <ul className="note-points">
                    <li>If you don’t have approved sheets, this module will display an empty page.</li>
                    <li>If you have approved sheets, you can view them here.</li>
                </ul>

                {/* Image Representation - Larger Size */}
                <img
                    className="placeholder-image image_gatnix_support"
                    src="https://res.cloudinary.com/danfpnuui/image/upload/v1737375497/Approval_sheets_vumjae.png"
                    alt="Approved Sheets"
                    style={{ width: "70%", height: "auto", maxWidth: "650px", margin: "20px 0" }} // Increased size
                />
            </div>
        </div>
    );
};

export default ViewApprovedSheets;
